import {MutationTree} from "vuex";
import {FinanceState} from "@/store/finance/types";

export const mutations: MutationTree<FinanceState> = {
  setBalances:(state, payload) => {
    state.balances = payload
  },
  setOverdrafts:(state, payload) => {
    state.overdrafts = payload
  }
}